import { MDBContainer, MDBRipple, MDBRow,MDBIcon,MDBCol } from "mdb-react-ui-kit";

import React, { useContext,useEffect } from 'react';
import { fetchMainPageData } from "../utils/Common";
import { Link } from 'react-router-dom';
import { NavbarContext } from "../context/NavProvider";
function EmptyCart() {
  const { isPricing,setIsPricing,pageData,setPageData,setBusiness} = useContext(NavbarContext);
  useEffect(() => {
    if (!pageData) {
      fetchMainPageData(setPageData,setIsPricing,pageData,setBusiness);      
    }
  }, []);
  
  return (
    <MDBContainer className="mb-2 position-relative grainy-gradient-intro justify-content-center text-center">

 
    <MDBRow>
      
    <MDBCol md='5' className="d-flex justify-content-center align-items-center " >
      <div className="d-flex-column justify-content-center text-center ">
<div className="d-flex  justify-content-center align-items-center " >
    <h3 >Cart is empty</h3>
  </div>
  {(isPricing || window.location.host.includes("expenses") || window.location.host.includes("x-trk")) &&  
    <div style={{ minWidth: '10rem', textAlign: 'center' }}>
      <Link to='/' >
        <p><MDBIcon fas icon="hand-point-left" /> Go Back to Subscribe</p>
      </Link>
    </div>
  }
  </div>
</MDBCol>

      <MDBCol className='p-2 text-center ' md='5'>

     
          <MDBRipple rippleTag='a' >
            <img
              src={'https://opengrit.com/images/shoppingCartFunctionalityIcon'}
              className='img-fluid rounded' style={{ height: '250px' ,width: '250px'}}
              alt='example'
            />
             <a href='#!'>
        <div className='mask' >
          <div className='d-flex justify-content-center align-items-center mt-3'>

         
          </div>
        
        </div>
      
      </a>
          </MDBRipple>

        </MDBCol>


    </MDBRow>
  </MDBContainer>
);
}

export default EmptyCart;

